import { useClients } from '@entities/clients';
import { useGetClientByIdQuery } from '@entities/clients/rtk-query';
import { useColorTags } from '@entities/common';
import type React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Note } from '@widgets/clients';
import {
  AcquiredEventsList,
  ConsultationList,
  GroupsList,
  NoteList,
  RentedProgramList,
  Tabs,
} from '@features/clients';
import { Profile } from '@features/clients/client-profile/ui';
import { ColorTagsList } from '@features/clients/colors-list';
import { useFilter, useLoadColorTags } from '@features/common';
import { Header } from '@features/events';
import { ArrowShortLeft } from '@shared/assets';
import { Card, IconButton, ListBody } from '@shared/ui';
import type { Note as Notemodel } from 'library/models/clients';
import * as st from './styles.module.scss';

export const EventClient: React.FC = () => {
  useLoadColorTags();
  const { clientId } = useParams();
  const navigate = useNavigate();
  const toBackLink = localStorage.getItem('toBackVisitor');

  const { setClient, clients, select } = useClients();
  const { searchNotes, onSearchNotes } = useFilter();
  const { colorTags, selectedColorTag, setSelectedColorTag, resetSelectedColorTag } =
    useColorTags();
  const { data, isLoading } = useGetClientByIdQuery(278); //убрать id когда появится поле в билете

  useEffect(() => {
    if (data) {
      select(data.id);
      setClient(data);
    }
  }, [isLoading, setClient]);

  const handleClickBack = () => {
    if (toBackLink) {
      navigate(toBackLink);
      localStorage.removeItem('toBackVisitor');
    }
  };

  return (
    <>
      <Header
        title="Участник мероприятия"
        left={
          <IconButton onClick={handleClickBack}>
            <ArrowShortLeft />
          </IconButton>
        }
      />

      <ListBody className={st.body}>
        <Card className={st.client}>
          {/*<ClientCard selectedColorTag={selectedColorTag!} />*/}

          <Tabs
            client={clients[0]}
            searchNotes={searchNotes}
            onSearchNotes={onSearchNotes}
            Profile={() => <Profile id={clients[0].id} />}
            Notes={(id: number, searchNotes: string) => (
              <NoteList key={id} id={clients[0].id} searchNotes={searchNotes}>
                {(note: Notemodel) => <Note key={note.pk} note={note} />}
              </NoteList>
            )}
            RentedPrograms={(id, code) => (
              <RentedProgramList key={`${id}-${code}`} id={id} code={code} />
            )}
            AssignedConsultations={(id, code) => <ConsultationList key={`${id}-${code}`} id={id} />}
            EventsList={(id, code) => (
              <AcquiredEventsList key={`${id}-${code}`} id={id} code={code} />
            )}
            GroupsList={(id: number) => <GroupsList id={id} key={`${id}-groups`} />}
            ColorsList={(id: number) => (
              <ColorTagsList
                id={Number(id)}
                colorTags={colorTags}
                selectedColorTag={selectedColorTag!}
                setSelectedColorTag={setSelectedColorTag}
                resetSelectedColorTag={resetSelectedColorTag}
              />
            )}
          />
        </Card>
      </ListBody>
    </>
  );
};
